module.exports = __webpack_public_path__ + "img/01_full.3f5858dc.jpg";